import { render, staticRenderFns } from "./QoList.vue?vue&type=template&id=0f6051ef&"
import script from "./QoList.vue?vue&type=script&lang=js&"
export * from "./QoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports